import React from 'react';
import { useStyletron } from 'baseui';
import { RELATIONSHIP_CONSTANTS } from '../../constants';
import type { RelationshipT } from '../../types/relationship';
import { formatFrameRange } from '../../utils';
import { RelationshipActionButtons } from '../relationship-action-button';
type RelationshipItemProps = {
  relationship: RelationshipT;
  targetDisplayName: string;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  isVideoTask?: boolean;
  readOnly?: boolean;
};
const RelationshipItem = ({
  relationship,
  targetDisplayName,
  onEdit,
  onDelete,
  isVideoTask,
  readOnly
}: RelationshipItemProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.backgroundPrimary,
    border: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`,
    borderRadius: theme.borders.radius300,
    boxSizing: 'border-box',
    gap: theme.sizing.scale400,
    padding: theme.sizing.scale500,
    width: '100%'
  })}>
      <div className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.sizing.scale100,
      flex: 1,
      minWidth: 0
    })}>
        <div className={css({
        ...theme.typography.LabelSmall,
        margin: 0,
        color: theme.colors.contentPrimary
      })}>
          {relationship.relationshipLabel.relationshipLabelName}
        </div>
        <div className={css({
        ...theme.typography.LabelXSmall,
        margin: 0,
        color: theme.colors.contentSecondary
      })}>
          {RELATIONSHIP_CONSTANTS.TARGET_PREFIX} - {targetDisplayName}
        </div>
        {isVideoTask && relationship.frameRanges.length > 0 && <div className={css({
        ...theme.typography.LabelXSmall,
        margin: 0,
        color: theme.colors.contentSecondary
      })}>
            {RELATIONSHIP_CONSTANTS.FRAMES}&nbsp;
            {relationship.frameRanges.map(frameRange => formatFrameRange(frameRange)).join(', ')}
          </div>}
      </div>

      {!readOnly && <RelationshipActionButtons relationshipId={relationship.id} onEdit={onEdit} onDelete={onDelete} showTooltip />}
    </div>;
};
export default RelationshipItem;